/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    alternative: { type: 'variant', values: [ true ] },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    iconPosition: {
      description: 'Theme styles to be applied to icon links depending on where the icon is in relation to the link text',
      type: 'state',
      values: [ 'left', 'right', 'inline' ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    quiet: {
      description: 'When it is true, it does not show the decoration',
      type: 'state',
      values: [ true, false ]
    },
    size: {
      description: 'Text sizes for block links; similar but not always identical to Typography sizes.',
      type: 'variant',
      values: [ 'micro', 'small', 'large' ]
    }
  },
  rules: [
    { if: { iconPosition: 'left' }, tokens: { iconSpace: 2 } },
    { if: { iconPosition: 'right' }, tokens: { iconSpace: 1 } },
    {
      if: { focus: true },
      tokens: {
        color: '#636c8c',
        outerBorderColor: '#636c8c',
        outerBorderOutline: 'none'
      }
    },
    {
      if: { hover: true },
      tokens: { color: '#394056', textLine: 'none' }
    },
    {
      if: { pressed: true },
      tokens: { color: '#2b3145', textLine: 'none' }
    },
    { if: { alternative: true }, tokens: { color: '#394056' } },
    {
      if: { alternative: true, hover: true },
      tokens: { color: '#2b3145' }
    },
    {
      if: { alternative: true, pressed: true },
      tokens: { color: '#2b3145', outerBorderWidth: 0 }
    },
    {
      if: { alternative: true, focus: true, pressed: true },
      tokens: { color: '#2b3145' }
    },
    {
      if: { alternative: true, focus: true },
      tokens: { color: '#394056', outerBorderColor: '#394056' }
    },
    {
      if: { alternative: true, focus: false, pressed: true },
      tokens: { color: '#2b3145' }
    },
    {
      if: { alternative: true, focus: true, hover: true, pressed: true },
      tokens: { color: '#2b3145', outerBorderColor: '#2b3145' }
    },
    {
      if: { alternative: true, focus: false, hover: true, pressed: false },
      tokens: { color: '#636c8c' }
    },
    {
      if: { alternative: true, focus: true, pressed: true },
      tokens: { color: '#636c8c' }
    },
    {
      if: { alternative: true, focus: true },
      tokens: {
        color: '#636c8c',
        outerBorderColor: '#636c8c',
        outerBorderWidth: 1
      }
    },
    {
      if: { alternative: true, pressed: true },
      tokens: { color: '#2b3145' }
    },
    { if: { inverse: true }, tokens: { color: '#f9f2dd' } },
    {
      if: { focus: true, inverse: true },
      tokens: { color: '#f9f2dd', outerBorderColor: '#f9f2dd' }
    },
    {
      if: { focus: true, inverse: true, pressed: true },
      tokens: { color: '#f39d80', outerBorderColor: '#f39d80' }
    },
    {
      if: { hover: true, inverse: true },
      tokens: { color: '#f9cebf' }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: { color: '#f39d80' }
    },
    {
      if: { size: 'micro' },
      tokens: {
        blockFontName: 'SofiaPro',
        blockFontSize: 14,
        blockFontWeight: '400',
        blockLineHeight: 1.4285714285714286,
        iconSize: 16
      }
    },
    {
      if: { size: 'small' },
      tokens: { blockFontSize: 16, blockLineHeight: 1.5, iconSize: 20 }
    },
    {
      if: { size: 'large' },
      tokens: { blockFontSize: 20, blockLineHeight: 1.4, iconSize: 24 }
    },
    { if: { quiet: true }, tokens: { textLine: 'none' } },
    {
      if: { hover: true, quiet: true },
      tokens: { color: '#394056', textLine: 'underline' }
    },
    {
      if: { alternative: true, hover: true, quiet: true },
      tokens: { color: '#2b3145', textLine: 'underline' }
    },
    {
      if: { hover: true, inverse: true, quiet: true },
      tokens: { color: '#f9cebf', textLine: 'underline' }
    }
  ],
  tokens: {
    alignSelf: 'flex-start',
    blockFontName: 'SofiaPro',
    blockFontSize: 18,
    blockFontWeight: '400',
    blockLineHeight: 1.55555555,
    borderRadius: 4,
    color: '#636c8c',
    icon: null,
    iconSize: 24,
    iconSpace: 0,
    iconTranslateX: 0,
    iconTranslateY: 0,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 2,
    outerBorderOutline: 'none',
    outerBorderWidth: 2,
    textLine: 'underline',
    textLineStyle: 'solid'
  }
}
export default theme
